/** Appends a folder name to a parent path; a null parent means the project root. */
export const joinFolderPath = (parentPath: string | null, folderName: string): string =>
  parentPath ? `${parentPath}/${folderName}` : folderName
